// Auth provider abstraction for shared services.
//
// Each consuming app must call configureSharedAuth() at startup with its own
// implementation (Cognito-backed in the Polish frontend, no-op stub in EAS).
// Shared services (HttpService, UserService) call these helpers without
// knowing which app they're running in.

export type SharedAuthProvider = {
    getRawIdTokenAsString: () => Promise<string>;
    getRawIdTokenWithGroups: () => Promise<[string, string[]]>;
};

let provider: SharedAuthProvider = {
    getRawIdTokenAsString: async () => '',
    getRawIdTokenWithGroups: async () => ['', []],
};

export function configureSharedAuth(p: SharedAuthProvider) {
    provider = p;
}

export function getRawIdTokenAsString(): Promise<string> {
    return provider.getRawIdTokenAsString();
}

export function getRawIdTokenWithGroups(): Promise<[string, string[]]> {
    return provider.getRawIdTokenWithGroups();
}
